import { useTokenInfo } from '@e2m-customer-portal/hooks';
import { UserRole } from '@e2m-customer-portal/shared';
import { Tooltip, TooltipProps } from '@mui/material';
import { InfoIcon } from 'assets/icons';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { JSX } from 'react/jsx-runtime';

const buildStringsFromField = (field: string, t: TFunction<'translation', undefined>, objectType?: string) => {
  const key = objectType ? `COPT_${objectType.toUpperCase()}_${field.toUpperCase()}` : `COPT_${field.toUpperCase()}`;
  return {
    builtTitle: t(key),
    builtText: <p className="m-0">{t(`${key}_TOOLTIP`)}</p>,
  };
};
type InfoTooltipProps = {
  placement?: TooltipProps['placement'];
  componentClass?: string;
  iconClass?: string;
  title?: string;
  children?: React.ReactElement | undefined;
} & (
  | { text: string | JSX.Element; field?: string; objectType?: string }
  | { text?: never; field: string; objectType?: string }
);

export const InfoTooltip = ({
  text,
  title,
  placement,
  componentClass,
  iconClass,
  field,
  objectType,
  children,
}: Readonly<InfoTooltipProps>) => {
  const { roles } = useTokenInfo();
  const [t] = useTranslation();
  const isFieldVisible = roles.has(UserRole.VPPOperator);
  let tooltipText: string | JSX.Element | undefined = text;
  let tooltipTitle = title;

  if (field && !text) {
    const { builtText, builtTitle } = buildStringsFromField(field, t, objectType);
    tooltipText = builtText;
    tooltipTitle = builtTitle;
  }
  return (
    <span className={componentClass ?? 'ml-2 pt-1'}>
      <Tooltip
        title={
          <>
            {tooltipTitle && <h4 className="mt-0">{tooltipTitle}</h4>}
            {tooltipText}
            {field && isFieldVisible && <p className="bg-grey-50 font-mono text-black p-1 rounded-sm w-fit">{field}</p>}
          </>
        }
        placement={placement ?? 'top'}
      >
        {children ?? <InfoIcon className={iconClass ?? 'w-4 sm:text-green-200'} />}
      </Tooltip>
    </span>
  );
};
